import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'jhi-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss']
})
export class ButtonComponent implements OnInit {
    isOnClickUsed = false;

    @Input() buttonLink: string;
    @Input() icon?: string;
    @Input() isLoading?: boolean;
    @Input() isDisabled?: boolean;

    @Output() onClick = new EventEmitter<any>();

    constructor(private router: Router) {}

    ngOnInit(): void {
        this.isOnClickUsed = this.onClick.observers.length > 0 || this.buttonLink !== undefined;
    }

    onClickButton(event: any) {
        if (this.buttonLink) {
            this.router.navigate([this.buttonLink]);
        } else {
            this.onClick.emit(event);
        }
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/components/forms/button/button.component.ts